import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { Outlet } from "react-router-dom";
import { GlobalContextProvider } from "../GlobalContext/context";
import CookiePolicyBanner from "../../CookiePolicyBanner"; 
import { useParams } from "react-router-dom";

export const Layout = ({ children }) => {
  const cookiesAccepted = localStorage.getItem("cookiesAccepted") === "true";
  const { param } = useParams();
  const text_coupon = `Coupons promotional code discounts sales`;
  let finalText = "";
  if (!!param) {
    finalText = param + ` ` + text_coupon;
  } else {
    finalText = text_coupon;
  }

  return (
    <GlobalContextProvider>
      <div className="wrapper layout-wrap">
        <>
          <NavBar />
          <main>
            {children}
            <Outlet />
          </main>
          <Footer />
        </>
        {cookiesAccepted ? <></> : <CookiePolicyBanner />}
      </div>
    </GlobalContextProvider>
  );
};
